import { Link } from 'react-router';
import { UserProfession } from '~/enums/UserProfession';
import { Colors } from '~/themes/colors';
import { Box, Column, Row, Text } from '~/commonComponents';
import { ProfessionalRating } from './ProfessionalRating';
import { IProfessionalCardUser } from '../../interfaces';

interface IProfessionalCardDetailsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetails = ({ user }: IProfessionalCardDetailsProps) => {
  const { id, fullname, profession, rating } = user;

  return (
    <Column justifyContent="center" marginLeft={24}>
      <Row alignItems="center" justifyContent="center" gap={8}>
        <Text
          bold
          fontSize={22}
          maxWidth={240}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {fullname}
        </Text>

        <Row alignItems="center" justifyContent="center" gap={7}>
          <ProfessionalRating rating={rating as number} />
          <Box height={20} width={2} backgroundColor={Colors.neutral_600} />
          <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
            <Text bold color={Colors.secondary_500} fontSize={20}>
              Profile
            </Text>
          </Link>
        </Row>
      </Row>
      <Column>
        <Text color={Colors.neutral_500}>{UserProfession.getName(profession || '')}</Text>
      </Column>
    </Column>
  );
};
